<template lang="html">
    <div class="use-common">
        <div class="activity_ends flex_box_column">
            <img class="activity_ends_icon" src="../assets/activityendsicon.png" alt="">
            <span class="activity_ends_text">活动已经结束了哦～</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {

        },
        data () {
            return {

            }
        },
        mounted() {

        },
        methods: {

        },
        watch: {

        }
    }
</script>

<style lang="less" scoped>
    /*活动已结束*/
    .activity_ends {
        align-items: center;
        padding-top: 380px;
        .activity_ends_icon {
            width: 220px;
            height: 220px;
        }
        .activity_ends_text {
            font-size:28px;
            font-weight:300;
            color:rgba(153,153,153,1);
            line-height:40px;
            margin-top: 20px;
        }
    }
</style>